import { Link } from 'expo-router';
import { memo } from 'react';

import { EnhancedInlineAlert, Text } from '@fhs/ui';
import { PulseAnimatedView } from '@fhs-legacy/frontend/src/components/ucl/pulse-animated-view';
import { useGeolocation } from '@fhs-legacy/frontend/src/state/geolocation';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { Geography } from '@fhs-legacy/frontend/src/utils/geography';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';
import {
  CHECKOUT_STORE_TOO_FAR_CALLOUT,
  NAVIGATE_TO_STORE_LOCATOR,
} from '@fhs-legacy/frontend/src/utils/test-ids';

function StoreTooFar() {
  const { userCoordinates, isPermissionGranted, loadCurrentPosition } = useGeolocation();
  const { store } = useStoreContext();

  const distanceInMiles =
    userCoordinates && store.latitude && store.longitude
      ? Geography.coordinateDistance(
          { latitude: userCoordinates.lat, longitude: userCoordinates.lng },
          { latitude: store.latitude, longitude: store.longitude },
          true
        )
      : 0;

  const maxDistanceInMiles = 10;
  const showAlert = maxDistanceInMiles < distanceInMiles || !isPermissionGranted;

  if (!showAlert) {
    return null;
  }

  const alertTitle = isPermissionGranted ? 'You seem far away' : 'You might be far away';

  const alertMessage = isPermissionGranted ? (
    <Text>
      Click{' '}
      <Link href={routes.storeLocator} testID={NAVIGATE_TO_STORE_LOCATOR}>
        <Text weight="bold" style={{ textDecorationLine: 'underline' }}>
          here
        </Text>
      </Link>{' '}
      to select a closer store
    </Text>
  ) : (
    <Text>
      Share{' '}
      <Text
        style={{ textDecorationLine: 'underline' }}
        onPress={loadCurrentPosition}
        testID="request-location-permission"
      >
        location
      </Text>{' '}
      to find closest store
    </Text>
  );

  return (
    <PulseAnimatedView>
      <EnhancedInlineAlert
        title={alertTitle}
        status="warning"
        message={alertMessage}
        testID={CHECKOUT_STORE_TOO_FAR_CALLOUT}
        style={{
          marginBottom: 24,
          borderRadius: 8,
          marginHorizontal: 16,
        }}
      />
    </PulseAnimatedView>
  );
}

export default memo(StoreTooFar);
